import { useScanDeviceApiListQuery } from '@hooks/api/useScanDeviceApiListQuery';
import type { VrsAccount } from 'types/api';

export const useVrsAccounts = useScanDeviceApiListQuery<VrsAccount>('/vrs-accounts');
